import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput, FormInputTrimmed, FormSelect, FormTextarea } from '@/_components';
import { locationsOptions } from '@/_schemas/generic';

import type { InfrastructureFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<InfrastructureFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Infrastructure (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="location"
        render={({ field }) => (
          <FormSelect
            formItemClassName="col-span-12 sm:col-span-6"
            disabled={!isEditable}
            value={field.value}
            onChange={field.onChange}
            options={locationsOptions}
            getOptionLabel={(option) => option.name}
            label="Location (required)"
          />
        )}
      />
      <FormField
        control={form.control}
        name="ip"
        render={({ field }) => (
          <FormInputTrimmed
            formItemClassName="col-span-12 sm:col-span-6"
            label="IP Address (v4) (required)"
            {...field}
            disabled={!isEditable}
          />
        )}
      />
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormTextarea label="Notes" {...field} disabled={!isEditable} formItemClassName="col-span-12" />
        )}
      />
    </>
  );
}
